<template>
  <li class="sub-header">
    <span>{{ header }}</span>
  </li>
</template>
<script>
export default {
	name: 'menu-header',
	props: {
		header: {
			type: String,
			required: true
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/mobile/mainMenu/MenuHeader.vue